const tabs = {
  lotto: [],
  cardGames: [],
  roulette: [],
  popular: [],
};

function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

export { getTab };
